module.exports = __webpack_public_path__ + "img/RTC11C.536ae7b8.svg";